import { createContext, useContext } from 'react';

// Each app's whoami query hook returns a differently-shaped result (admin
// carries AI-assistant fields, system carries 2FA/session fields, etc.), so
// this is a factory rather than one shared context — each app instantiates
// its own with its own hook's return type, while sharing this file's
// Provider-guard logic. `ProtectedRoute` must be the only caller of that
// app's whoami query hook; every other consumer under it (layouts included)
// reads the single result from here instead. A second independent query
// subscription races with the first one's fetches (the initial mount fetch
// and the tab-focus refetch can overlap) and can permanently miss a cache
// broadcast, leaving that second hook's data stuck on stale/undefined even
// though the cache itself holds the correct value. See DAT-1551.
export default function createWhoamiContext<T>() {
  const WhoamiContext = createContext<T | null>(null);

  function useWhoamiContext(): T {
    const context = useContext(WhoamiContext);
    if (!context) {
      throw new Error('useWhoamiContext must be used within its Provider');
    }
    return context;
  }

  return { WhoamiContext, useWhoamiContext };
}
